<template>
    <b-overlay :show="loading" rounded="sm">
    <div>
        <view-item v-if="!!item" :item="item" @success="alertSuccess" @delete-item="deleteType" @cancel="item = null"
            @error="showError"></view-item>

        <list-items v-if="!item" title="ItemTypes" :items="assetTypes" @show-item="showItem" ref="table">
            <button id="create-asset-schedule-type-btn" class="btn btn-primary btn-block" variant="primary" block v-if="hasPermissionCreate"
                @click="item = {}"><img v-b-tooltip.hover :title="$addLabel()"
                    src="@/assets/images/icon/blue-add.svg" /></button>
        </list-items>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

export default {
    name: 'AssetTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
            loading: false,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('asset_type') },

        assetTypes() {
            const types = this.$store.state.assets.types
            console.log('types', types)
            return types
        },
    },

    methods: {
        async doSearch() {
            this.loading = true
            await this.$store.dispatch('assets/listTypes')
            this.loading = false
        },

        showItem(id) {
            const item = this.assetTypes.find(x => x.id === id)
            this.item = { ...item }
        },

        showError(error) {
            // const interror = 'Internal Server Error'
            this.genericToast(
                this.componentName,
                this.$translate('error'),
                'danger',
                `${error}`
            )
        },

        alertSuccess(action, name, message) {
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" ${message}`
            )

            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
